/**
 * App 主组件 - 重构版
 */

import React from 'react';
import { HashRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Home, Details, Register, Status } from './pages';

const Header: React.FC = () => {
  const location = useLocation();
  const isHidden = location.pathname === '/status';

  if (isHidden) return null;

  return (
    <nav className="sticky top-0 z-50 glass border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <img 
            src="https://aimaster.aiscenes.cn/assets/images/AIscenes-logo-BEENeMHy.png" 
            alt="AI场景大师" 
            className="h-8 w-auto object-contain"
          />
          <div className="hidden sm:flex flex-col border-l border-slate-200 pl-3">
            <span className="text-xs font-bold text-slate-400 uppercase tracking-widest leading-none mb-1">OPC PRACTICE</span>
            <span className="text-sm font-bold text-blue-900 leading-none">创新实践赛报名</span>
          </div>
        </Link>
        <div className="flex items-center gap-4 sm:gap-8">
          <Link to="/" className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors py-2">首页</Link>
          <a href="https://www.aiscenes.cn/" target="_blank" rel="noreferrer" className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors py-2 hidden md:inline">平台官网</a>
          <Link to="/details" className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors py-2">赛事详情</Link>
          <Link to="/register" className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-bold hover:bg-blue-700 transition-all shadow-md shadow-blue-200 active:scale-95">
            立即报名
          </Link>
        </div>
      </div>
    </nav>
  );
};

const Footer: React.FC = () => (
  <footer className="py-12 border-t border-slate-200 mt-auto bg-white">
    <div className="max-w-4xl mx-auto px-4 text-center">
      <div className="flex justify-center items-center gap-4 mb-6 grayscale hover:grayscale-0 transition-all opacity-70">
         <img 
            src="https://aimaster.aiscenes.cn/assets/images/AIscenes-logo-BEENeMHy.png" 
            alt="AI场景大师" 
            className="h-6 w-auto"
          />
      </div>
      <div className="text-slate-500 text-xs sm:text-sm space-y-2">
        <p>© 2026 AI 场景大师 · 苏州市中小学人工智能线上冬令营</p>
        <p>本页面为 AI 场景大师平台专属赛事报名入口</p>
        <p className="text-slate-400">技术支持：<a href="https://www.aiscenes.cn/" className="underline hover:text-blue-600">aiscenes.cn</a></p>
      </div>
    </div>
  </footer>
);

function App() {
  return (
    <HashRouter>
      <div className="min-h-screen flex flex-col font-sans">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/details" element={<Details />} />
            <Route path="/register" element={<Register />} />
            <Route path="/status" element={<Status />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;
